import React, { useEffect, useState } from 'react';
import SystemDashboard from 'layouts/SystemDashboard';
import {
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Breadcrumbs,
  Link,
} from '@mui/material';
import {
  deleteAttachment,
  getAllAttachments,
  getFile,
} from './AttachmentService';

import { useNavigate } from 'react-router-dom';
// import { alpha, useTheme } from '@mui/material/styles';
// import pdfIcon from 'http://localhost:3000/assets/pdfIcon.png';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
// import ListItemAvatar from '@mui/material/ListItemAvatar';
import Container from 'components/Container';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';
// import FileUpload from './FileUpload';

const AttachmentList = (): JSX.Element => {
  // const theme = useTheme();

  const [attachments, setAttachments] = useState<any[]>([]);
  const [filePreviews, setFilePreviews] = useState({});

  const [loading, setLoading] = useState(false); // State variable to track loading state
  const [openDialog, setOpenDialog] = useState(false);
  const [attachmentIdToDelete, setAttachmentIdToDelete] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    listAttachments();
  }, []);

  function listAttachments(): void {
    console.log('listAttachments called 000');

    setLoading(true);
    getAllAttachments()
      .then((response) => {
        setAttachments(response.data);
        loadFilePreviews(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      })
      .finally(() => {
        setLoading(false);
      });
  }

  // function refreshAttachments() {
  //   console.log('refreshAttachments called 000');
  //   listAttachments();
  // }

  function loadFilePreviews(attachments) {
    const previews = {};
    attachments.forEach((attachment) => {
      if (attachment.contentType === 'application/pdf') {
        // If the attachment is a PDF, use the PDF icon image
        // previews[attachment.filename] = pdfIcon;
      } else {
        // If it's not a PDF, fetch the thumbnail as before
        getFile(attachment.filename)
          .then((response) => {
            previews[attachment.filename] = URL.createObjectURL(
              new Blob([response.data]),
            );
            setFilePreviews({ ...previews });
          })
          .catch((error) => {
            console.error('Error fetching file:', error);
            notify(extractErrorMessage(error));
          });
      }
    });
  }

  function addAttachment() {
    navigate('/system/dashboard/add-attachment');
  }

  function selectAttachment(attachmentid) {
    console.log(attachmentid);
    navigate(`/system/dashboard/attachment/${attachmentid}`);
  }

  const handleDeleteConfirmation = (itemId) => {
    setAttachmentIdToDelete(itemId);
    setOpenDialog(true);
  };

  const handleDeleteItem = () => {
    // Call your removeItem function to delete the item
    removeAttachment(attachmentIdToDelete);
    // Close the dialog
    setOpenDialog(false);
  };

  function removeAttachment(attachmentid) {
    deleteAttachment(attachmentid)
      .then(() => {
        // Item deleted successfully, update the list
        listAttachments();
      })
      .catch((error) => {
        // Handle errors or exceptions
        if (error.response) {
          // The request was made and the server responded with a status code
          // Display an error message based on the response status
          console.error(
            'Request failed with status code:',
            error.response.status,
          );
          // Check if the error is due to a foreign key constraint violation
          if (
            error.response.status === 400 &&
            typeof error.response.data === 'string' &&
            error.response.data.includes('foreign key constraint')
          ) {
            // Display a user-friendly error message informing the user that they can't delete the item
            notify(
              'Cannot delete the item because it is referenced by other records.',
            );
          }
          if (error.response.status === 401) {
            // Display a user-friendly error message informing the user that they can't delete the item
            notify(
              'Cannot delete or update a parent row: a foreign key constraint fails.',
            );
          } else {
            // Display a generic error message for other types of errors
            notify(
              'An error occurred while deleting the item. Please try again later.',
            );
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error(
            'Request made but no response received:',
            error.request,
          );
        } else {
          // Something happened in setting up the request that triggered an error
          console.error('Error setting up the request:', error.message);
        }
      });
  }

  return (
    <Container>
      <SystemDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System Content
            </Link>
            <Typography color="text.primary">Attachments</Typography>
          </Breadcrumbs>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={4}
        >
          <Typography variant="h4">Attachments</Typography>
          <Button variant="contained" onClick={addAttachment}>
            Add Attachment
          </Button>
        </Box>
        {loading && <p>Loading...</p>}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 750 }} aria-label="simple table">
            <TableHead sx={{ bgcolor: 'alternate.main' }}>
              <TableRow>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    ID
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    Thumbnail
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    Name
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    File Name
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    Content Type
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    Size
                  </Typography>
                </TableCell>
                <TableCell />
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                  Are you sure you want to delete this attachment?
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                  <Button onClick={handleDeleteItem} autoFocus>
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
              {attachments.map((item, i) => (
                <TableRow
                  key={i}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  onClick={() => selectAttachment(item.id)}
                >
                  <TableCell component="th" scope="row">
                    <ListItem sx={{ p: 0, m: 0 }}>
                      <ListItemText primary={item.id} secondary={item.id} />
                    </ListItem>
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {filePreviews[item.filename] && (
                      <img
                        src={filePreviews[item.filename]}
                        alt="Thumbnail"
                        style={{ width: 50 }}
                      />
                    )}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <ListItem sx={{ p: 0, m: 0 }}>
                      <ListItemText primary={item.name} secondary={item.id} />
                    </ListItem>
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <ListItem sx={{ p: 0, m: 0 }}>
                      <ListItemText
                        primary={item.filename}
                        secondary={item.id}
                      />
                    </ListItem>
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <ListItem sx={{ p: 0, m: 0 }}>
                      <ListItemText
                        primary={item.contentType}
                        secondary={item.id}
                      />
                    </ListItem>
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <ListItem sx={{ p: 0, m: 0 }}>
                      <ListItemText primary={item.size} secondary={item.id} />
                    </ListItem>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={'primary'}
                      variant={'subtitle2'}
                      fontWeight={700}
                      sx={{ cursor: 'pointer' }}
                    >
                      Edit
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={'primary'}
                      variant={'subtitle2'}
                      fontWeight={700}
                      sx={{ cursor: 'pointer' }}
                    >
                      <IconButton
                        onClick={(event) => {
                          event.stopPropagation(); // Stop the click event from propagating
                          handleDeleteConfirmation(item.id); // Show confirmation dialog before deleting
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </SystemDashboard>
    </Container>
  );
};

export default AttachmentList;
